import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useDisclosure } from '@bonusly/design-system';

import { useActionInput } from '../../../context';
import { useIsEnabled } from '../../../hooks/use-is-enabled';
import { DecorationButton } from '../decoration-button';
import { DoodleModal } from './doodle-modal';

const ScribbleLoopIcon: FC = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		fill="none"
		stroke="currentColor"
		strokeWidth="19"
		strokeLinecap="round"
		strokeLinejoin="round"
		viewBox="0 0 256 256"
	>
		<path d="M32,92.8S64,48,112,48c104,0,92.6,160-3.4,160-64,0-64-96,32-96,64,0,107.4,48,107.4,48" />
	</svg>
);

interface DoodleButtonProps {
	decorationVariant?: 'default' | 'list-item';
}

export const DoodleButton: FC<DoodleButtonProps> = ({ decorationVariant = 'default' }) => {
	const { t } = useTranslation('action_input');
	const isEnabled = useIsEnabled('doodle');
	const { isOpen, onOpen, onClose } = useDisclosure();
	const { onUpload } = useActionInput();

	const handleSave = async (file: File) => {
		await onUpload(file);
	};

	if (!isEnabled) return null;

	return (
		<>
			<DecorationButton label={t('doodle.tooltip')} onClick={onOpen} decorationVariant={decorationVariant}>
				<ScribbleLoopIcon />
			</DecorationButton>
			<DoodleModal isOpen={isOpen} onClose={onClose} onSave={handleSave} />
		</>
	);
};
